import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/api/client';
import { getDataOrThrowApiError } from '@/lib/api/error';
import { QUERY_PRESETS } from '@/lib/query';

// アプリ/サービス単位のカウント。registered=連携・台帳登録済み、all=検知アプリ数。
// （旧 /accesses/count は生のアクセス数で直感的でないため software/count に変更）
async function getDetectedSoftwareCount() {
  const res = await apiClient.GET('/v2/accesses/software/count');
  return getDataOrThrowApiError(res);
}
const INITIAL_DATA = {
  all: 0,
  blocked: 0,
  registered: 0,
  tolerated: 0
} as const;
export function useDetectedSoftwareCount() {
  return useQuery({
    queryKey: ['accesses', 'overview', 'software-count'],
    queryFn: getDetectedSoftwareCount,
    initialData: INITIAL_DATA,
    ...QUERY_PRESETS.list()
  });
}

// 利用メンバーの母数（在籍メンバー総数 ALL_ACTIVE）。利用率の分母に使う。
async function getActiveMemberCount() {
  const res = await apiClient.GET('/v2/people/count');
  return getDataOrThrowApiError(res);
}
export function useActiveMemberCount() {
  return useQuery({
    queryKey: ['accesses', 'overview', 'active-member-count'],
    queryFn: getActiveMemberCount,
    ...QUERY_PRESETS.list()
  });
}